import * as React from "react";
const SvgLoaderCircle = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 7A6 6 0 1 1 7 1", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round" }));
export default SvgLoaderCircle;
